export default "__VITE_ASSET__VKdXJn7y__"